import React from 'react';
import {Box} from '../box';
import {Typography} from '../typography';
import {FrameworkImage} from '../image-renderer';

export interface ArtistDescriptionProps {
  image?: string | null;
  description?: string;
  isStudioPage?: boolean;
}

export const ArtistDescription: React.FC<ArtistDescriptionProps> = ({
  image,
  description,
  isStudioPage,
}: ArtistDescriptionProps) => {
  if (!image) return null;
  return (
    <Box flexDirection={['column', 'row']}>
      <Box flex="1">
        <Box marginX={['zero', 'twelve']} marginY={['zero', 'eight']}>
          <Typography color="textDefault" fontSize="lead">
            {description}
          </Typography>
        </Box>
      </Box>
      <Box flex="1">
        <Box
          height={['510px', '388px', '486px', '596px', '784px']}
          width={['100%', '270px', '350px', '446px', '600px']}
          css={{float: 'right'}}
          marginX={['zero', 'twelve']}
          marginY={['zero', 'eight']}
        >
          <FrameworkImage
            src={image}
            layout="fill"
            objectFit="cover"
            alt={image || ''}
          />
        </Box>
      </Box>
    </Box>
  );
};
